import React from "react"
import { SITE_CONFIG } from "../../lib/constants"

export function LogoWithText() {
  return (
    <div className="flex items-center gap-2">
      <div className="relative w-8 h-8">
        <img src="/images/logo.svg" alt="Syllepsis logo" className="w-full h-full" />
      </div>
      <span className="font-light text-xl tracking-tight text-muted-foreground -mt-0.5">
        s<span className="font-normal">yllepsis</span>
      </span>
    </div>
  )
}